import { OrganizationRoleType } from "../../autogen/bff-api";

const adminOrOwnerRoles: OrganizationRoleType[] = [OrganizationRoleType.Admin, OrganizationRoleType.Owner];

const creatorRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Admin,
  OrganizationRoleType.Owner,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.ContractCreator,
  OrganizationRoleType.ProjectCreator,
];

const orgEntryUpdateRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.ContractCreator,
];

export const isOwnerOrAdmin = (roles: OrganizationRoleType[]) => adminOrOwnerRoles.some((role) => roles.includes(role));

export const isCreator = (roles: OrganizationRoleType[]) => creatorRoles.some((role) => roles.includes(role));

export const canUpdateOrgEntry = (roles: OrganizationRoleType[]) =>
  orgEntryUpdateRoles.some((role) => roles.includes(role));
